import { Directive, Inject, Input, OnInit, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Directive({
    selector: '[stickyClass]'
})
export class StickyComponent implements OnInit {
    private _marker: HTMLElement;
    private _originalOffset: number;

    @Input() stickyClass: string = 'sticky';
    @Input() stickyMarkerId: string = 'sticky-marker';
    @Input() stickyMarkerClass: string;
    @Input() ieOnly: boolean = true;

    constructor(
        @Inject(DOCUMENT)
        private _document: Document,
        private _element: ElementRef,
        private _renderer: Renderer2) { 
    }

    ngOnInit() {
        if (this.stickyMarkerClass) {
            this._marker = this._document.querySelector('.' + this.stickyMarkerClass) as HTMLElement;
        } else { 
            this._marker = this._document.getElementById(this.stickyMarkerId);
        }
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        let agent = window.navigator.userAgent;
        let ie = agent.indexOf('MSIE') > 0 || agent.indexOf('Trident/') > 0;
        let enabled = ie || !this.ieOnly;
        
        if (this._marker && enabled) {
            let offset = this._marker.offsetTop;
            var scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

            if (scrollY >= offset) {
                if (!this._element.nativeElement.classList.contains(this.stickyClass)) {
                    let elementWidth = this._element.nativeElement.width || this._element.nativeElement.clientWidth;
                    if (elementWidth > 0)
                        this._renderer.setStyle(this._element.nativeElement, 'width', '' + elementWidth + 'px');
                    this._renderer.addClass(this._element.nativeElement, this.stickyClass);
                }
            } else {
                if (this._element.nativeElement.classList.contains(this.stickyClass)) {
                    this._renderer.removeClass(this._element.nativeElement, this.stickyClass);
                    this._renderer.removeStyle(this._element.nativeElement, 'width');
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/sticky.component.ts